module.exports = __webpack_public_path__ + "static/media/intro_wall2.ea184d20.png";


//////////////////
// WEBPACK FOOTER
// ./src/Conviot/Intro/img/intro_wall2.png
// module id = 186
// module chunks = 0